import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
// 引入附件上传页面
import CorpPictureinfor from '@/views/page/components/pictureinfor/index.vue';
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [],
      // 温馨提示
      tipList: [
        /*{
          type: "text",
          text: "联系人姓名、联系人办公电话、联系人手机号码 、联系邮箱须与《企业（市场主体）管理员授权委托书》的填写内容相符。"
        },
        {
          type: "slot",
          slotName: "url"
        }*/
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        personName: null, // 项目负责人名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "姓名：",
          value: "personName",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "personName",
        },
        {
          label: "性别",
          prop: "sexNum",
          width: 80,
        },
        {
          label: "核验状态",
          prop: "auditStateName",
        },
        {
          label: "证件类型",
          prop: "idCardTypeName",
        },
        {
          label: "证件号码",
          prop: "idCard",
          width: 200,
        },
        {
          label: "出生日期",
          prop: "birthDay",
        },
        {
          label: "民族",
          prop: "nationlityName",
        },
        {
          label: "学历",
          prop: "eduLevelNum",
        },
        {
          label: "手机号码",
          prop: "mobile",
        },
        {
          label: "操作",
          slotName: "operation",
          width: 180
        },
      ],
      // 表格数据
      tableData: [],
      userFlag: null, // 用户标识
      userType: null, // 用户类型
      multipleSelection: [], // 勾选数组
      // 异动资料的文件路径
      fileUrl: null,
      // 全局加载
      fullLoading: null,
    };
  },
  // 注册组件
  components: {
    // 附件上传一览
    CorpPictureinfor,
  },

  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
    // 获取异动资料的路径
    this.fun_GetFileUrl();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/regPersonBasicinfoChoose/autoList", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
     fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 转入
     */
    fun_Join() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选的数据大于1条
        if (this.multipleSelection.length > 1) {
          this.$alert("只能选择一行数据！", "warning");
          return;
        }
        // 弹出询问confirm
        this.$confirm("确认要将此项目负责人转入？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 打开遮罩
          this.fun_Loading();
          // 请求，获取结果集
          fun_PostAction("/regPersonBasicinfoChoose/updateAutoRegPerson", {
            key: this.multipleSelection[0].id,
          }).then(res => {
            // 加载框取消
            this.fullLoading.close();
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 刷新当前页面
            this.fun_GetList();
          })
          .catch(() => {
            // 加载框取消
            this.fullLoading.close();
          });
        });

      } else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning")
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 查看文件
     */
    fun_GetPictureinfor(e) {
      // 打开弹窗
      this.$refs.corpPictureinfor.dialogVisible = true;
      // 赋值数据编号
      this.$refs.corpPictureinfor.form.recordNumber = e.id.replaceAll('-', "") + '_36';
      // 打开弹框时调用
      this.$refs.corpPictureinfor.fun_GetOpen();
    },
    /**
     * 获取异动资料的路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "异动资料"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 图片压缩.zip的路径
          this.fileUrl = data;
        }
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$emit("fun_Back");
    },
  }
};
